import Configurator from "../views/Configurator/Configurator.jsx";
import ThankYouPage from "../views/Pages/ThankYou.jsx";
import ConfiguratorEN from "../views/ConfiguratorEN/Configurator.jsx";
import ThankYouPageEN from "../views/PagesEN/ThankYou.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";

var configuratorRoutes = [
	{
		path: "/de/configurator",
		name: "Configurator",
		icon: DashboardIcon,
		component: Configurator
	}, {
		path: "/de/thankyou",
    name: "Thank you Page",
    short: "Thanks",
    mini: "TY",
    component: ThankYouPage
	},
	{
		path: "/en/configurator",
		name: "Configurator",
		icon: DashboardIcon,
		component: ConfiguratorEN
	}, {
		path: "/en/thankyou",
    name: "Thank you Page",
    short: "Thanks",
    mini: "TY",
    component: ThankYouPageEN
	},
	{ redirect: true, path: "/", pathTo: "/de/configurator", name: "Configurator" }
];

export default configuratorRoutes;



// WEBPACK FOOTER //
// ./src/routes/configurator.jsx